import CONSTANTS from '../../constants/api.constants';
import { conversionAmount } from '../../constants/app.constants';
import { conversionRateActionTypes as ACTION } from '../actionTypes';

export const loadInitialData = () => {
  return async (dispatch) => {
    try {
      const response = await fetch(CONSTANTS.conversionApiUrl);
      const data = await response.json();
      dispatch({
        type: ACTION.SET_CONVERSION_RATE,
        payload: data?.[0]?.rate || conversionAmount,
      });
    } catch (error) {
      dispatch({
        type: ACTION.SET_CONVERSION_RATE,
        payload: conversionAmount,
      });
    }
  };
};